import { getStoredTagKey } from "../../hooks/useTagKey";
import type { FieldRenderer } from "../types";

const renderer: FieldRenderer = (fieldValue: unknown) => {
  if (Array.isArray(fieldValue)) {
    const targetTagKey = getStoredTagKey();
    const tags = fieldValue.map((item) => {
      if (
        typeof item === "object" &&
        item !== null &&
        "key" in item &&
        "value" in item
      ) {
        const tagItem = item as { key: string; value: string };
        if (tagItem.key === targetTagKey) {
          return tagItem.value;
        }
      }
      return "";
    });
    return {
      formattedText: tags.filter(Boolean).join(", "),
    };
  }
  return {
    formattedText: "",
  };
};

export default renderer;
